import * as React from 'react';
import PageSkeletonLoader from './page-skeleton-loader';
import TableSkeletonLoader from './table-skeleton-loader';
import './style.less';

const supportedViews = {
    page: 'page',
    table: 'table'
}

interface ISkeletonLoaderProps {
    type?: string;
    tableType?: string;
    columns?: number;
    rows?: number;
    subRows?: number;
    page?: object;
}

const SkeletonLoader: React.FC<ISkeletonLoaderProps> = (props: ISkeletonLoaderProps) => {
    return (
        <div className="tc-st-skeleton-loader-container">
            {props.type === supportedViews.page ?
            <PageSkeletonLoader page={props.page}/> : <TableSkeletonLoader type={props.tableType}
                rows={props.rows}
                columns={props.columns}
                subRows={props.subRows}/>}
        </div>
    )
}

export default SkeletonLoader;
